<template>
	<div>
		<PlayerHeader
			:title="scoreTitle"
			:artist="scoreArtistName"
			:artistURL="scoreArtistURL"
			:difficulties="scoreDifficulties"
		/>
		
		<hr>
		
		<PlayerMain :targetScore="scoreSourceName"></PlayerMain>

		<hr>

		<PlayerFooter
			:poem="scorePoem"
			:bpm="scoreBPM"
			:comments="scoreComments"
			:originalSource="scoreOriginalSource"
			:banner="scoreBanner"
			:event="eventProp"
		/>
	</div>
</template>

<script>
import scores from '../assets/scorelist.json';
import PlayerHeader from "../components/danoni/PlayerHeader.vue";
import PlayerMain from "../components/danoni/PlayerMain.vue";
import PlayerFooter from "../components/danoni/PlayerFooter.vue";
export default {
	title() {
		return this.score()['title'];
	},
	components: {
		PlayerHeader: PlayerHeader,
		PlayerMain: PlayerMain,
		PlayerFooter: PlayerFooter,
	},
	computed: {
		scoreTitle() {
			return this.score()['title'];
		},
		scoreArtistName() {
			return this.score()['artist'];
		},
		scoreArtistURL() {
			return this.score()['artist-url'];
		},
		scoreDifficulties() {
			return this.score()['difficult'];
		},
		scoreSourceName() {
			return this.score()['source']
		},
		scorePoem() {
			return this.score()['poem']
		},
		scoreBPM() {
			return this.score()['bpm']
		},
		scoreComments() {
			return this.score()['comments']
		},
		scoreOriginalSource() {
			return this.score()['original-source']
		},
		scoreBanner() {
			return this.score()['banner'];
		},
		eventProp() {
			return this.score()['event'];
		},
	},
	methods: {
		score() {
			return scores.find((score) => {
				return score['source'] == this.$route.params.source;
			});
		},
	}

}
</script>

<style>

</style>